import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { selectInstructionCardData } from '../../data/pageInfoCardData'
import { dataWithModal } from '../../data/checkboxData'
import { cancelModalContent } from '../../data/modalContentData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import PageHeader from '../../components/PageHeader'
import InstructionCard from '../../components/InstructionCard'
import CheckBox from '../../components/CheckBox'
import FooterText from '../../components/PageFooter/FooterText'
import PairNavButton from '../../components/PairNavButton'
import PageModal from '../../components/PageModal'

const SelectAccount = () => {
  const navigate = useNavigate()
  const [modalData, setModalData] = useState({ isOpen: false, data: {} })
  const [selectedAccount, setSelectedAccount] = useState(0)
  const [navModalBtnFocused, setNavModalBtnFocused] = useState(false)
  const [focusedInfoModalBtnIndex, setfocusedInfoModalBtnIndex] = useState(null)

  useEffect(() => {
    if (navModalBtnFocused) {
      setNavModalBtnFocused(false)
    }
    if (focusedInfoModalBtnIndex !== null) {
      setfocusedInfoModalBtnIndex(null)
    }
  }, [navModalBtnFocused, focusedInfoModalBtnIndex])

  function closeModal(index) {
    setModalData({ ...modalData, isOpen: false })
    if (index === undefined) {
      setNavModalBtnFocused(true)
    } else {
      setfocusedInfoModalBtnIndex(index)
    }
  }

  function toggleAccountInfoModal(index) {
    if (modalData.isOpen) {
      closeModal(index)
    } else {
      setModalData({
        isOpen: true,
        onClose: () => closeModal(index),
        data: {
          title: checkboxData.data[index].title,
          content: [
            checkboxData.data[index].content,
            checkboxData.data[index].description,
          ],
        },
      })
    }
  }

  function toggleCancelModal() {
    if (modalData.isOpen) {
      closeModal()
    } else {
      setModalData({
        isOpen: true,
        onClose: () => closeModal(),
        data: {
          ...cancelModalContent,
          leftButton: 'No',
          leftButtonFunc: () => closeModal(),
          rightButton: 'Yes',
          rightButtonFunc: () => navigate('/process-cancel'),
        },
      })
    }
  }

  function toggleSelectedAccount(title, checked) {
    // bugfix: because checkbox-onClick and onChange trigger same time, so we set !check replace checked in advance here
    if (!checked) {
      setSelectedAccount(selectedAccount + 1)
    } else {
      setSelectedAccount(selectedAccount - 1)
    }
  }
  let checkboxContentData = dataWithModal.map((item, index) => ({
    ...item,
    toggleModel: (index) => () => toggleAccountInfoModal(index),
    toggleChecked: (title, checked) => () =>
      toggleSelectedAccount(title, checked),
  }))

  const checkboxData = {
    title: 'Accounts',
    toggleSelection: (num) => setSelectedAccount(num),
    data: checkboxContentData,
    focusedInfoModalBtnIndex: focusedInfoModalBtnIndex,
  }

  const footerText = (
    <p>
      If you have any questions or concerns about sharing data go to
      bank1.com.au/cdr
    </p>
  )
  const BottomNavButtonData = {
    leftButton: 'Cancel',
    leftButtonFunc: () => toggleCancelModal(),
    isLeftBtnFocused: navModalBtnFocused,
    rightButton: 'Continue',
    rightButtonFunc: () => navigate('/confirm-share'),
    isRightButtonDisabled: selectedAccount === 0 ? true : false,
    leftButtonLabel:
      'cancel button, to open the cancel process modal double click here',
    rightButtonLabel:
      selectedAccount === 0
        ? 'continue button Disabled, please select at least one of your accounts'
        : 'continue button, to visit next page double click here',
  }

  return (
    <PageWrapper isModalOpen={modalData.isOpen}>
      <Helmet>
        <title>Select your accounts</title>
        <link rel="icon" href="./asset/bankIcon.svg" />
      </Helmet>
      <PageContentWrapper isModalOpen={modalData.isOpen}>
        <PageHeader
          headerTitle="Bank 1"
          workflow="Auth"
          isFocused={true}
          titleLabel="banks 1: Select your accounts"
        />
        <InstructionCard {...selectInstructionCardData} />
        <CheckBox {...checkboxData} />
        <FooterText content={footerText} isDepenednt={true} />
        <PairNavButton {...BottomNavButtonData} />
      </PageContentWrapper>
      <PageModal {...modalData} />
    </PageWrapper>
  )
}

export default SelectAccount
